module.exports = __webpack_public_path__ + "img/rewind.84405f9c.svg";